/**
 * @mixin
 * adds TableColumn tab to DataInputMenu
 * */

import { mapGetters } from 'vuex';
import { getAction } from '@/store/modules/actions/getters';
import { getService } from '@/store/modules/apps/getters';
import { getNodeByUuidForSelectedWorkflowVersion } from '@/store/modules/selectedWorkflow/getters';
import { getWidgetFieldData } from '@/store/modules/widgets/getters';

import ParamsService from '@/utils/ParamsService';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import TableActionEditorService from '@/components/BlockEditor/TableActionEditor/table-action-edtior-service';
import ParamBaseDataInputMenuMixin from './ParamBaseDataInputMenuMixin';
import TableColumnExtenderDataInputMenuMixinService from './table-column-extender-data-input-menu-mixin-service';
import { PREVIOUS_STEP_TABLE_OUTPUT } from '@/components/DataInput/DataInputMenu/helpers/data-input-menu.const';

export default {
	mixins: [ParamBaseDataInputMenuMixin],
	props: {
		items: { type: Array },
		sourceOfList: { type: String },
	},
	computed: {
		...mapGetters([getNodeByUuidForSelectedWorkflowVersion.fullPath, getAction.fullPath, getService.fullPath, getWidgetFieldData.fullPath]),
		tableItems() {
			return this.items;
		},
		tableColumnDataInputMenuProps() {
			return { items: this.tableItems };
		},
		isDropdownInput() {
			return this.isConditionDependsOnTable && this.acceptsSingularValue && !this.allowCustomValue;
		},
		sourceData() {
			return TableActionEditorService.sourceDataForDataInputMenu(
				this.sourceOfList,
				this[getNodeByUuidForSelectedWorkflowVersion.fullPath],
				this[getAction.fullPath]
			);
		},
	},
	methods: {
		async updateLocalValueFromTable(value) {
			let processedValue = value;
			if (this.curTabCode === PREVIOUS_STEP_TABLE_OUTPUT) {
				const processedValueWithoutBrackets = ParamsService.getValueFromTableColumnKey(processedValue);
				const { isDynamic, userSchemaMappingsSourceFieldUuid, sourceTableServiceId, sourceTableActionId } = this.sourceData;
				if (
					isDynamic &&
					userSchemaMappingsSourceFieldUuid &&
					this.needsToBeMapped(sourceTableServiceId, sourceTableActionId, processedValueWithoutBrackets)
				) {
					processedValue = ParamsService.buildKeyForTableColumn(`${userSchemaMappingsSourceFieldUuid}.${processedValueWithoutBrackets}`);
					await this.openAddMappingToMapperDialog(userSchemaMappingsSourceFieldUuid, sourceTableServiceId, processedValueWithoutBrackets);
				}
			}
			this.updateValueFromMenu(processedValue);
		},
		needsToBeMapped(serviceId, actionId, value) {
			return !ParamsService.getSkipKeysForMapping(this[getService.fullPath](serviceId), this[getAction.fullPath](actionId)).includes(value);
		},
		async openAddMappingToMapperDialog(userSchemaMappingsSourceFieldUuid, serviceId, value) {
			const itemKeyToMap = value.split('.')[0]; // we map only the first level of the itemKey
			// check if this is needed for mapping and if first of its mapping and if so - open dialog for mapping item
			const data = this[getWidgetFieldData.fullPath](userSchemaMappingsSourceFieldUuid);
			const mapping = data.widgetField?.metadata?.source?.mappings.find((m) => m.originalKey === itemKeyToMap);
			if (!mapping) {
				await AppDialogManagerService.openAddMappingToMapperDialog({
					originalKey: itemKeyToMap,
					widgetFieldUUID: userSchemaMappingsSourceFieldUuid,
					service: this[getService.fullPath](serviceId),
				});
			}
		},
	},
	mounted() {
		if (this.isConditionDependsOnTable) {
			TableColumnExtenderDataInputMenuMixinService.addTableColumnsTabItem.call(this);
			TableColumnExtenderDataInputMenuMixinService.addTableColumnListenerDataInput.call(this);
		}
	},
	watch: {
		tableColumnDataInputMenuProps: {
			handler() {
				TableColumnExtenderDataInputMenuMixinService.setTableColumnDataInputMenuProps.call(this);
			},
			deep: true,
			immediate: true,
		},
	},
};
